import { Pagination } from 'services/medicalRecords/pagination.types'

export interface Option {
  id: number | string
  name: string
}

export interface OptionsResponse {
  pagination: Pagination
}

export const OTHER_MEDICATION_OPTION_ID = 362
export const NONE_MEDICATION_OPTION_ID = 361

export const OTHER_COMPLAINT_OPTION_ID = 402

export const OTHER_SYMPTOM_OPTION_ID = 102
